import React from 'react'
import { StyleSheet, View } from 'react-native'

// components
import BaseObject, { BaseObjectProps } from 'components/BaseObject'
import ActionWrapper from 'components/ActionWrapper'

export interface SectionProps extends BaseObjectProps {
  component?: any
  bindingData?: {}
}

export default class Section<T extends SectionProps> extends BaseObject<T> {
  additionalStyles() {
    return {}
  }

  renderBackground() {
    return null
  }

  render() {
    const { object, children, bindingData } = this.props
    const { attributes, layout } = object

    let {
      paddingLeft,
      paddingRight,
      paddingTop,
      paddingBottom,
      ...layoutStyles
    } = layout

    let wrapperStyles = {
      ...layoutStyles,
      ...this.additionalStyles(),
      opacity: attributes.opacity,
    }

    let innerWrapperStyles = {
      paddingLeft,
      paddingRight,
      paddingTop,
      paddingBottom,
    }

    let borderOffset = this.getBorderOffset()
    const borderStyles = this.borderStyles()
    let borderWidth = borderStyles.borderWidth || 0

    let borderPadding = 0.5 * borderWidth + borderOffset

    let backgroundStyles = {
      ...this.shadowStyles(),
      ...borderStyles,
      ...this.backgroundStyles(),
      left: -borderPadding,
      top: -borderPadding,
      right: -borderPadding,
      bottom: -borderPadding,
    }

    let backgroundOverlayStyles = {
      borderRadius: this.getBorderRadius(true),
    }

    let backgroundOverlayInnerStyles = {
      flex: 1,
      margin: -borderPadding,
    }

    return (
      <ActionWrapper
        bindingData={bindingData}
        object={object}
        style={[wrapperStyles]}
      >
        <View style={[styles.background, backgroundStyles as any]}>
          <View style={[styles.backgroundOverlay, backgroundOverlayStyles]}>
            <View style={backgroundOverlayInnerStyles}>
              {this.renderBackground()}
            </View>
          </View>
        </View>
        <View style={[innerWrapperStyles, { height: layout.height }]}>
          {children}
        </View>
      </ActionWrapper>
    )
  }
}

const styles = StyleSheet.create({
  background: {
    position: 'absolute',
  },
  backgroundOverlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'hidden',
  },
})
